/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { eventBus } from "./eventBus";
import JobCardDetail from "./components/JobCardDetail.vue";
import TimeLogs from "./components/TimeLogs.vue";
import QtyDialog from "./components/QtyDialog.vue";

const __vue_script__ = {
  name: "Home",
  components: { JobCardDetail, TimeLogs, QtyDialog },
  props: ["doc"],
  data: () => {
    return {
      action: "",
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    goToPrev() {
      window.location.search = "?secret=" + this.doc.prev;
    },
    goToNext() {
      window.location.search = "?secret=" + this.doc.next;
    },
    onStart() {
      frappe.freeze("Loading...");
      frappe
        .call({
          method: "mesrajaya.api.start_job_card",
          args: { job_card: this.doc.name },
        })
        .then(async (res) => {
          if (res.message.success) {
            eventBus.$emit("load-doc");
            frappe.unfreeze();
          } else {
            frappe.unfreeze();
            frappe.throw(res.message.message);
          }
        })
        .catch((err) => {
          frappe.unfreeze();
        });
    },
    onPause() {
      this.action = "Pause";
      $("#QtyDialog").modal("show");
    },
    onEnd() {
      frappe.freeze("Loading...");
      frappe
        .call({
          method: "mesrajaya.api.pause_job_card",
          args: {
            job_card: this.doc.name,
            completed_qty: this.doc.remaining_qty,
          },
        })
        .then(async (res) => {
          if (res.message.success) {
            frappe.unfreeze();
            eventBus.$emit("load-doc");
          } else {
            frappe.unfreeze();
            frappe.throw(res.message.message);
          }
        })
        .catch((err) => {
          frappe.unfreeze();
        });
    },
  },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container mx-auto" }, [
    _c("h5", { staticClass: "text-center mb-0 mt-4" }, [
      _vm._v("\n    Job Card"),
      _vm.doc ? _c("span", [_vm._v(" - " + _vm._s(_vm.doc.name))]) : _vm._e()
    ]),
    _vm._v(" "),
    _vm.doc
      ? _c(
          "div",
          [
            _c("qty-dialog", {
              attrs: {
                docname: this.doc.name,
                max: _vm.doc.remaining_qty,
                action: _vm.action
              }
            }),
            _vm._v(" "),
            _c("job-card-detail", { attrs: { doc: _vm.doc } }),
            _vm._v(" "),
            _c("time-logs", { attrs: { logs: _vm.doc.time_logs } }),
            _vm._v(" "),
            _vm.doc.web_status == "Open"
              ? _c("div", { staticClass: "text-center py-4" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-lg btn-primary",
                      on: { click: _vm.onStart }
                    },
                    [_vm._v("Start")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.doc.web_status == "Started"
              ? _c(
                  "div",
                  { staticClass: "d-flex justify-content-between py-4" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-lg btn-primary",
                        on: { click: _vm.onPause }
                      },
                      [_vm._v("Pause")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      { staticClass: "btn btn-lg", on: { click: _vm.onEnd } },
                      [_vm._v("End")]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.doc.web_status == "Paused"
              ? _c("div", { staticClass: "text-center py-4" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-lg btn-primary",
                      on: { click: _vm.onStart }
                    },
                    [_vm._v("Resume")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.doc.web_status == "End"
              ? _c(
                  "div",
                  { staticClass: "d-flex justify-content-between py-4" },
                  [
                    _vm.doc.prev
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-lg",
                            on: { click: _vm.goToPrev }
                          },
                          [_vm._v("\n        Previous\n      ")]
                        )
                      : _c("span"),
                    _vm._v(" "),
                    _vm.doc.next
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-lg",
                            on: { click: _vm.goToNext }
                          },
                          [_vm._v("\n        Next\n      ")]
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-10acef34_0", { source: "\n.container[data-v-10acef34] {\n  max-width: 576px;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n", map: {"version":3,"sources":["../mesrajaya/mesrajaya/public/js/job_card_web/Home.vue"],"names":[],"mappings":";AAyHA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AACA","file":"Home.vue","sourcesContent":["<template>\n  <div class=\"container mx-auto\">\n    <h5 class=\"text-center mb-0 mt-4\">\n      Job Card<span v-if=\"doc\"> - {{ doc.name }}</span>\n    </h5>\n\n    <div v-if=\"doc\">\n      <qty-dialog\n        :docname=\"this.doc.name\"\n        :max=\"doc.remaining_qty\"\n        :action=\"action\"\n      />\n      <job-card-detail :doc=\"doc\" />\n      <time-logs :logs=\"doc.time_logs\" />\n\n      <div class=\"text-center py-4\" v-if=\"doc.web_status == 'Open'\">\n        <button class=\"btn btn-lg btn-primary\" @click=\"onStart\">Start</button>\n      </div>\n      <div\n        class=\"d-flex justify-content-between py-4\"\n        v-if=\"doc.web_status == 'Started'\"\n      >\n        <button class=\"btn btn-lg btn-primary\" @click=\"onPause\">Pause</button>\n        <button class=\"btn btn-lg\" @click=\"onEnd\">End</button>\n      </div>\n      <div class=\"text-center py-4\" v-if=\"doc.web_status == 'Paused'\">\n        <button class=\"btn btn-lg btn-primary\" @click=\"onStart\">Resume</button>\n      </div>\n      <div\n        class=\"d-flex justify-content-between py-4\"\n        v-if=\"doc.web_status == 'End'\"\n      >\n        <button v-if=\"doc.prev\" @click=\"goToPrev\" class=\"btn btn-lg\">\n          Previous\n        </button>\n        <span v-else></span>\n        <button v-if=\"doc.next\" @click=\"goToNext\" class=\"btn btn-lg\">\n          Next\n        </button>\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport { eventBus } from \"./eventBus\";\nimport JobCardDetail from \"./components/JobCardDetail.vue\";\nimport TimeLogs from \"./components/TimeLogs.vue\";\nimport QtyDialog from \"./components/QtyDialog.vue\";\n\nexport default {\n  name: \"Home\",\n  components: { JobCardDetail, TimeLogs, QtyDialog },\n  props: [\"doc\"],\n  data: () => {\n    return {\n      action: \"\",\n    };\n  },\n  created() {},\n  mounted() {},\n  computed: {},\n  methods: {\n    goToPrev() {\n      window.location.search = \"?secret=\" + this.doc.prev;\n    },\n    goToNext() {\n      window.location.search = \"?secret=\" + this.doc.next;\n    },\n    onStart() {\n      frappe.freeze(\"Loading...\");\n      frappe\n        .call({\n          method: \"mesrajaya.api.start_job_card\",\n          args: { job_card: this.doc.name },\n        })\n        .then(async (res) => {\n          if (res.message.success) {\n            eventBus.$emit(\"load-doc\");\n            frappe.unfreeze();\n          } else {\n            frappe.unfreeze();\n            frappe.throw(res.message.message);\n          }\n        })\n        .catch((err) => {\n          frappe.unfreeze();\n        });\n    },\n    onPause() {\n      this.action = \"Pause\";\n      $(\"#QtyDialog\").modal(\"show\");\n    },\n    onEnd() {\n      frappe.freeze(\"Loading...\");\n      frappe\n        .call({\n          method: \"mesrajaya.api.pause_job_card\",\n          args: {\n            job_card: this.doc.name,\n            completed_qty: this.doc.remaining_qty,\n          },\n        })\n        .then(async (res) => {\n          if (res.message.success) {\n            frappe.unfreeze();\n            eventBus.$emit(\"load-doc\");\n          } else {\n            frappe.unfreeze();\n            frappe.throw(res.message.message);\n          }\n        })\n        .catch((err) => {\n          frappe.unfreeze();\n        });\n    },\n  },\n};\n</script>\n\n<style scoped>\n.container {\n  max-width: 576px;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-10acef34"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../mesrajaya/mesrajaya/public/js/job_card_web/Home.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__